import { apiClient } from './api';
import {
  StartNovelSessionRequest,
  NovelSessionStartResponse,
  GenerateNovelOutlineRequest,
  NovelOutlineResponse,
  CreateCharacterProfileRequest,
  CharacterProfileResponse,
  CreateLocationRequest,
  LocationResponse,
  GenerateNovelChapterRequest,
  NovelChapterResponse,
  NovelSessionStatusResponse
} from '../models/novelWriting';

export class NovelWritingService {
  static async startSession(request: StartNovelSessionRequest): Promise<NovelSessionStartResponse> {
    const response = await apiClient.post('/api/novel/session/start', request);
    return response.data;
  }

  static async generateOutline(sessionId: string, request?: GenerateNovelOutlineRequest): Promise<NovelOutlineResponse> {
    const response = await apiClient.post(`/api/novel/session/${sessionId}/generate-outline`, request || {});
    return response.data;
  }

  static async createCharacterProfile(sessionId: string, request: CreateCharacterProfileRequest): Promise<CharacterProfileResponse> {
    const response = await apiClient.post(`/api/novel/session/${sessionId}/create-character`, request);
    return response.data;
  }

  static async createLocation(sessionId: string, request: CreateLocationRequest): Promise<LocationResponse> {
    const response = await apiClient.post(`/api/novel/session/${sessionId}/create-location`, request);
    return response.data;
  }

  static async generateChapter(sessionId: string, request: GenerateNovelChapterRequest): Promise<NovelChapterResponse> {
    const response = await apiClient.post(`/api/novel/session/${sessionId}/generate-chapter`, request);
    return response.data;
  }

  static async getSessionStatus(sessionId: string): Promise<NovelSessionStatusResponse> {
    const response = await apiClient.get(`/api/novel/session/${sessionId}`);
    return response.data;
  }
}

export default NovelWritingService;